<template>
  <div v-if="program">
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false"
      :hide-separators="true"
      :title="`Espace acquéreur ${p ? ': ' + p.name : ''}`">
    </page-nav-bar>
    <page-content
      :has-left-col-xsmall="true"
      :has-sticky-col-left="true"
      :has-padd-right-normal="true"
      :set-main-col-class="''">
      <template slot="left-col-small">
        <aside class="menu menu--admin">
          <ul class="menu-list has-background-white is-border">
            <li class="is-active">
              <ul>
                <li
                  :class="{'is-active' : panel === 'AFFICHAGE'}"
                  id="tabs-AFFICHAGE">
                  <a @click="panel = 'AFFICHAGE'">
                    <div class="is-uppercase">PARAMÉTRES D’AFFICHAGE</div>
                  </a>
                </li>
                <li
                  :class="{'is-active' : panel === 'TIMELINE'}"
                  id="tabs-TIMELINE">
                  <a @click="panel = 'TIMELINE'">
                    <div class="is-uppercase">FIL D’ACTUALITÉ DU PROGRAMME</div>
                  </a>
                </li>
                <li
                  :class="{'is-active' : panel === 'DOCS'}"
                  id="tabs-DOCS">
                  <a @click="panel = 'DOCS'">
                    <div class="is-uppercase">DOCUMENTS ET PHOTOS</div>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </aside>
      </template>
      <div v-if="program && panel">
        <div
          class="has-background-white is-border"
          v-show="panel === 'AFFICHAGE'">
          <buyer-space-affichage
            @patchProgram="patchProgram"
            :program="program"></buyer-space-affichage>
        </div>
        <div
          class="has-background-white is-border"
          v-show="panel === 'TIMELINE'">
          <buyer-space-timeline
            :program="program"
            @sliceEvent="sliceEvent"
            @updateTimeline="updateTimeline"
            :timeline="timeline"></buyer-space-timeline>
        </div>
        <div
          class="has-background-white is-border"
          v-show="panel === 'DOCS'">
          <buyer-space-docs
            :program="program"
            :timeline="timeline"></buyer-space-docs>
        </div>
      </div>
    </page-content>
  </div>
</template>

<script>
import ProgramMixin from './ProgramMixin'

export default {
  name: 'ProgramBuyerSpace',
  components: {
    BuyerSpaceAffichage: () => import('@/components/programs/BuyerSpaceAffichage'),
    BuyerSpaceTimeline: () => import('@/components/programs/BuyerSpaceTimeline'),
    BuyerSpaceDocs: () => import('@/components/programs/BuyerSpaceDocs')
  },
  mixins: [ProgramMixin],
  data () {
    return {
      timeline: [],
      panel: 'AFFICHAGE'
    }
  },
  created () {
    if ('panel' in this.$route.query) {
      this.panel = this.$route.query.panel
    }
    this.getTimeline()
  },
  methods: {
    sliceEvent (pk) {
      let idx = this.timeline.findIndex(x => {
        return x.pk === pk
      })
      if (idx >= 0) {
        this.timeline.splice(idx, 1)
      }
    },
    updateTimeline (idx, results) {
      if (idx >= 0) {
        this.timeline.splice(idx, 1, results)
      } else {
        this.timeline.push(results)
      }
    },
    async getTimeline () {
      try {
        let { data } = await this.$api.get(`/programs/${this.$route.params.id}/timeline`)
        this.timeline = data.items
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>
